import dynamic from 'next/dynamic';
import css from './rivermax.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';
import { getImageSpec } from '@/utils/locals';

const webpUrl = '/media/rivermax/pc/';
const PageConPc = dynamic(() => import('@/components/productRiver/rivermax/indexDynamic'), {
    ssr: true,
});

export default function RiverMax() {
    const { useRouter, useLang } = useGlobal();
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['au', 'uk', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za']);
    const { t } = useLang('rivermaxportablepowerstation');
    const banner_items = [
        {
            bgImgs: [`rivermax_banner_${imgSpec}.webp`, `rivermax_banner_${imgSpec}.jpg`],
            title: t('river_max.banner_title'),
            des: t('river_max.banner'),
        },
    ];

    return (
        <div className={`${css.animationWrapper}`}>
            <div style={{ width: '100%', marginTop: '-70px' }}>
                <BannerModule
                    config={{
                        position: 'top',
                        titleFontSize: 80,
                        theme: 'black',
                        webpUrl,
                    }}
                    data={banner_items}
                />
            </div>
            <PageConPc />
        </div>
    );
}
